<template>
    <CollapsibleCardBase>
        <template #title>
            <div class="mt-1 font-bold text-sm">
                {{ $t('component.missionProfile.help.title') }}
            </div>
        </template>
        <template #content>
            <div class="text-sm leading-tight text-gray-600">
                <div class="w-full flex p-1" v-if="missionDetail.situation.existing_aids.support">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.help.support') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div>
                            <div class="mb-1 ml-1">{{ missionDetail.situation.existing_aids.support }}</div>
                        </div>
                    </div>
                </div>

                <div class="w-full flex p-1" v-if="missionDetail.situation.existing_aids.aids.length > 0">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.help.aids') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div class="ml-1 mb-1">{{ aids().join(', ') }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1" v-if="missionDetail.situation.existing_aids.pauses !== undefined || missionDetail.situation.existing_aids.pauses !== false">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.help.aids_pauses') }}</div>
                    </div>
                    <div class="w-2/3 text-black">
                        <div>
                            <div class="mb-1 ml-1">{{ $t('component.missionProfile.help.aids_pauses_yes') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </CollapsibleCardBase>
</template>

<script>
    import CollapsibleCardBase from "@/components/shared/CollapsibleCardBase";
    export default {
        name: "MissionProfileHelp",
        props: ['missionDetail'],
        components: {CollapsibleCardBase},
        methods: {
            aids() {
                let aids = [];
                let self = this;

                if (this.missionDetail.situation.existing_aids.aids === undefined)
                    return aids;

                this.missionDetail.situation.existing_aids.aids.forEach(function (c) {
                    switch (c) {
                        case '0':
                            aids.push(self.$t('text.aids_0'));
                            break;
                        case '1':
                            aids.push(self.$t('text.aids_1'));
                            break;
                        case '2':
                            aids.push(self.$t('text.aids_2'));
                            break;
                        case '3':
                            aids.push(self.$t('text.aids_3'));
                            break;
                        case '4':
                            aids.push(self.$t('text.aids_4'));
                            break;
                        case '6':
                            aids.push(self.$t('text.aids_6'));
                            break;
                        case '7':
                            aids.push(self.$t('text.aids_7'));
                            break;
                    }
                });

                return aids;
            }
        }
    }
</script>

<style scoped>

</style>